export const targetGroupActionTypes = {
    STORE_TARGET_GROUPS: "STORE_TARGET_GROUPS",
}